import { ReactElement } from 'react';

import { IframeExtension } from '@localstack/ui';
import { Alert, Link } from '@mui/material';

import { getExtensionUiURL, getSelectedInstance, useLocalstackStatus } from '@localstack/services';
import { ExternalLink } from '@localstack/constants';

import { InstanceViewProps } from '../props';

export const Snowflake = ({ Layout }: InstanceViewProps): ReactElement => {
  const instance = getSelectedInstance();
  const { isSnowflake: isSnowflakeRunning } = useLocalstackStatus({ endpoint: instance?.endpoint });

  return (
    <Layout maxWidth="lg" title="Snowflake">
      {!isSnowflakeRunning && (
        <Alert severity="warning">
          Snowflake emulator is not running. Please start the Snowflake container to access this view. See the{' '}
          <Link
            href={ExternalLink.DOC_SNO_GETTING_STARTED}
            target="_blank"
            rel="noreferrer"
            color="inherit"
            underline="always"
          >
            Getting Started guide
          </Link>
          .
        </Alert>
      )}
      {isSnowflakeRunning && <IframeExtension url={getExtensionUiURL(instance, 'snowflake')} />}
    </Layout>
  );
};
